export const INVITE_ACTIONS = {
  SET_USER: 'invite/setUser',
  ACCEPT_INVITE: 'invite/acceptInvite',
  DECLINE_INVITE: 'invite/declineInvite',
  SEND_ANSWER: 'invite/sendAnswer',
};
